import { useState } from "react";

import FabBar from "@/design/components/FabBar";
import Valkyrie, { viLocationPinDot } from "@sippy-platform/valkyrie";

import { Button, List, Popover, Typography } from "@mui/material";
import { amber, grey, lightGreen, lime, orange, yellow } from "@mui/material/colors";
import PropTypes from "prop-types";

import DestinationList from "./DestinationList";

function DestinationPicker({ timetable, setActiveDestination, activeDestination, getGoTo }) {
  const [destinationsAnchor, setDestinationsAnchor] = useState(null);

  const destiantionsOpen = Boolean(destinationsAnchor);

  const openDestinations = (event) => setDestinationsAnchor(event.currentTarget);
  const closeSettings = () => setDestinationsAnchor(null);

  function setDestinationAndClosePicker(rule) {
    setActiveDestination(rule ?? null);
    closeSettings();
  }

  const activeItem = getGoTo(activeDestination?.overflow || timetable?.overflow);

  return (
    <>
      <FabBar>
        <Button
          variant="contained"
          onClick={openDestinations}
          id="destinationPicker"
          aria-label="Open destiantions"
          style={{
            backgroundColor: activeDestination?.color || "#fff",
            color:
              [lime[500], yellow[500], amber[500], orange[500], lightGreen[500], grey[500]].indexOf(
                activeDestination?.color,
              ) >= 0 || activeDestination?.id === undefined
                ? "#000"
                : "#fff",
          }}
        >
          <Valkyrie icon={activeItem?.icon || viLocationPinDot} />
        </Button>
      </FabBar>
      <Popover
        open={destiantionsOpen}
        anchorEl={destinationsAnchor}
        onClose={closeSettings}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        slotProps={{ paper: { sx: { width: 268, maxHeight: 500, mt: -1 } } }}
      >
        <Typography variant="h6" sx={{ mx: 1.5, my: 1 }}>
          Destinations
        </Typography>
        <List sx={{ px: 1, pb: 1 }}>
          <DestinationList
            timetable={timetable}
            activeDestination={activeDestination}
            setActiveDestination={setDestinationAndClosePicker}
            getGoTo={getGoTo}
          />
        </List>
      </Popover>
    </>
  );
}

DestinationPicker.propTypes = {
  timetable: PropTypes.object,
  activeDestination: PropTypes.object,
  setActiveDestination: PropTypes.func,
  getGoTo: PropTypes.func,
};

export default DestinationPicker;
